import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from './Store';

/**
 * Typed variant of `useDispatch` for this application.
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();

/**
 * Typed variant of `useSelector` for this application.
 */
export const useAppSelector = useSelector.withTypes<RootState>();
